import JobContact from "@/components/Shared/JobContact";
import JobPostingSchema from "@/components/JobPostingSchema";
import JobPageContacts from "@/components/JobPage/JobPageContacts";
import JobPageHeader from "@/components/JobPage/JobPageHeader";
import JobPageDescription from "@/components/JobPage/JobPageDescription";
import OtherJobs from "@/components/Shared/OtherJobs";
import SEO from "@/components/SEO";
import Jobs from "@sourceflow-uk/sourceflow-sdk/jobs";
import stripTags from "@/functions/stripTags";
import localizePath from "@/functions/localizePath";

export default function JobPostPage({ locale = "en", job }) {
  return (
    <>
      <SEO
        path={localizePath(`/jobs/${job.url_slug}`, locale)}
        title={`${job?.title} | Jobs | Lawrence Harvey`}
        description={stripTags(job?.description)}
      />
      <JobPostingSchema job={job} />
      <main className="bg-white pt-[240px] h-full pb-[145px]">
        <div className="container">
          <JobPageHeader job={job} />
          <div className="lg:pl-[72px] flex flex-col lg:flex-row my-16 justify-between gap-5 lg:gap-10">
            <div className="flex flex-col gap-14">
              <JobPageDescription job={job} />
              <div className="w-full h-[0.25px] bg-purple" />
              <JobPageContacts job={job} />
            </div>
            <OtherJobs job={job} />
          </div>
        </div>
        <JobContact job={job} />
      </main>
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const jobs = (await Jobs()).getItems();
  const job = jobs.find(
    (job) => decodeURI(job.url_slug) === decodeURI(url_slug),
  );

  return { props: { job } };
}

export async function getStaticPaths() {
  const paths = (await Jobs())
    .getItems()
    .map((i) => ({ params: { url_slug: decodeURI(i.url_slug) } }));

  return {
    paths,
    fallback: false,
  };
}
